import React, { useEffect, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { useTranslation } from "react-i18next";
import OTPInput from "react-otp-input";
import { useDispatch } from "react-redux";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Link, useNavigate } from "react-router-dom";
import loginApi from "../../api/LoginApi";
import OTPVerify from "../../api/OtpVerifyApi";
import { resendOtp } from "../../api/resendOtp";
import { SETUSERDATA } from "../../redux/features/userData";
import { checkOtpValid } from "../../utils/CheckOtpValid";
import { countries, customLabels } from "../../utils/countries";
import LoaderButton from "../Buttons/LoaderButton";
import { setCookie } from "../../utils/helper";
import Konsole from "../../utils/konsole/Konsole";
import GlobalButton from "../Buttons/btn2/GlobalButton";

const initialTime = 30


export default function OtpView() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  Konsole.log("loading", loading);
  const [error, setError] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  // const [timer,setTimer] = useState(initialTime)
    const storedTime = sessionStorage.getItem("timer");
  const [timer, setTimer] = useState(storedTime ? parseInt(storedTime) : initialTime);


  useEffect(() => {
    if (sessionStorage.getItem("yop-phone") == null) {
      navigate("/login");
    }
  }, [navigate]);

 useEffect(() => {
    // Save timer to sessionStorage on change
    sessionStorage.setItem("timer", `${timer}`);

    // Stop if timer reaches 0
    if (timer <= 0) return;

    const interval = setInterval(() => {
      setTimer(prevTimer => {
        const newTimer = prevTimer - 1;
        sessionStorage.setItem("timer", `${newTimer}`); // update storage every tick
        return newTimer;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsSubmit(true);
    if (checkOtpValid(otp)) {
      setLoading(true);
      const data = await OTPVerify(otp);

      if (data.success) {

        // localStorage.setItem("yop-token", data.token);
        setCookie('yop-token', data.token, 7);
        dispatch(SETUSERDATA(data.user_data));
        setCookie('user-data',JSON.stringify(data?.user_data),7)
        if (data.user_data.is_profile_complete == 0) {

          setLoading(false);
          navigate("/register", {
            replace: true,
          });
        } else {

          setLoading(false);
          navigate(sessionStorage.getItem("previous-page") || "/", {
            replace: true,
          });
        }
      } else {
        setError(data?.message)
        setLoading(false);

        setOtp('')
      }
    }else{
      setError(t("VerifyOtp.error"))
    }
  };

  useEffect(() => {
    if (isSubmit) {
      if (!checkOtpValid(otp)) {
        setError(t("VerifyOtp.error"));
      } else {
        setError("");
      }
    }
  }, [otp, isSubmit]);

  const resendOtpHandler = async () => {
    setLoading(true);
    setTimer(initialTime)
    await resendOtp();
    setError("")
    setLoading(false);
  };

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

   useEffect(() => {
      const urlPath = window.location.pathname
      if (urlPath == '/verify-otp') {
        document.body.classList.add('login_otp_overflow');
      }
  
      return () => {
        document.body.classList.remove('login_otp_overflow');
      }
    }, []);

  // console.log(error,"error")

  return (
    <>
      <form onKeyDown={handleKeyPress}>
        <div className="md:p-20">
          <div className="store-card menu max-w-[26rem] h-screen md:h-auto  m-auto">
            <h1 className="font-normal text-2xl font-splekta mb-3">
              {t("VerifyOtp.verifyWithOtp")}
            </h1>
            <p className="text-[#606060] textMd font-normal mb-6">
              {" "}
              {sessionStorage.getItem("yop-phone")}
            </p>
            <div className="mb-5 relative">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                inputType="tel"
                renderInput={(props) => <input {...props} />}
                containerStyle="justify-between gap-2"
                inputStyle="!border border-[#D2D2D2] !w-full rounded-sm p-4 text-base !rounded-lg ubermoveTextNormal"
              />
              {error && <div className="errorFields">{error}</div>}
            </div>
            <GlobalButton label= {t("VerifyOtp.continue")} onClick={handleSubmit} loading={loading} />
            <div className="mt-5 flex justify-between  ubermoveTextNormal textMd textBlue  ">
              <Link to="/login">{t("VerifyOtp.changeNumber")}</Link>
             {timer > 0 ? <p className="cursor-pointer">
                {t("VerifyOtp.resendOtpIn")} {timer} {timer == 1 ? t("VerifyOtp.second") : t("VerifyOtp.seconds")}
              </p> : <p className="cursor-pointer" onClick={resendOtpHandler}>
                {t("VerifyOtp.resendOtp")}
              </p>}
            </div>
          </div>
        </div>
      </form>
         </>
  );
}
